import axios from 'axios';
import { useSnackbar } from 'notistack';
import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { QRCodeCanvas } from 'qrcode.react';

function PaymentCheck(props) {
    const { enqueueSnackbar } = useSnackbar();
    const [showErr, setShowErr] = useState(false)
    const { mandateID, mobileMode, partner } = useSelector((state) => state.mandateInfo);
    const { mandateData } = useSelector((state) => state.mandateInfo);
    const checkPayment = useCallback(async () => {
        let data = {
            "unique_id": mandateID ? mandateID : mandateData?.unique_id,
        }
        let response = await axios({
            url: process.env.REACT_APP_API_COMMON + 'upi/confirm',
            method: 'post',
            maxBodyLength: Infinity,
            headers: {
                'Authorization': 'Bearer ' + process.env.REACT_APP_API_KEY
            },
            data: data
        })
        if (response) {
            if (response?.data?.Status === 'Success') {
                window.location.assign(response?.data?.redirect_url)
            }
            else {
                setShowErr(response?.data?.Message)
            }
        }
        else {
            return enqueueSnackbar(response?.Message, {
                variant: "error",
                autoHideDuration: 3000,
                preventDuplicate: true,
            });
        }
    }, [])

    useEffect(() => {
        let intervalId;

        if (mandateData?.unique_id) {
            checkPayment();

            intervalId = setInterval(() => {
                checkPayment();
            }, 10000);
        }

        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, [mandateData?.unique_id]);
    return (
        <div class="container mt-5">
            <div class="col-12">
                <div class="text-center mb-5">
                    {props?.qrCode && <QRCodeCanvas value={props?.qrCode} size={256} />}
                    {!props?.qrCode &&
                        <>
                            <p class="fw-medium fs-6 mb-3">Authorization valid for ONLY 2 mins! Check your UPI APP to approve & register Instantly!</p>
                            <p class="fw-medium fs-6 mb-3">The notification has been sent to the UPI Payment Application. The page will automatically redirect once the payment gets completed.</p>
                            <p class="fw-bold fs-6  mb-3">Please don't refresh the page!</p>
                        </>}
                    {props?.qrCode &&
                        <>

                            <p class="fw-medium fs-6 mb-3">Please open the UPI App and scan the QR to complete the payment</p>
                        </>}
                    <button class="btn DloadBtn d-none" type='button' onClick={() => { checkPayment() }}>
                        <div class="details">
                            <p>Check Status</p>
                        </div>
                    </button>
                    {showErr &&
                        <div class="mt-4 gap-2">
                            <div class="alert alert-danger alert-dismissible fade show" role="alert">
                                <p class="mb-1">{showErr}</p>
                                <button type="button" class="btn-close" data-bs-dismiss="alert" onClick={() => { setShowErr(false) }} aria-label="Close">&#215;</button>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default PaymentCheck